'use strict';

function slickSlidersInit() {

	/*******************************************************************************
 * 1.0 - FEATURED SLIDER
 *******************************************************************************/

	// Featured articles slider
	$('.test-slider').slick({
		//centerMode: true,
		//speed: 500,
		//centerPadding: '0px',
		//slidesToShow: 1,
		//slidesToScroll: 1,
		adaptiveHeight: true,
		infinite: false,
		dots: true,
		fade: true,
		cssEase: 'ease-in',
		arrows: true,
		appendArrows: $('.featured-slider-arrows'),
		prevArrow: '<div class="nav-arrow : nav-arrow--prev"></div>',
		nextArrow: '<div class="nav-arrow : nav-arrow--next"></div>'
	}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {

		//var currentSlide = nextSlide + 1;
		//var totalSlides = slick.slideCount;
		//$('.gallery-modal-counter').html(currentSlide + " / " + totalSlides);

	});
}